<template>
  <div style="margin-top: 10px;margin-left: 30px;">
    <el-form class="board-form" ref="boardForm" :model="boardForm" label-width="100px">
      <el-card shadow="hover" :body-style="{ height: '20px' }">
        <el-form-item label="企业的Logo" prop="companyLogo" label-width="140px">
          <el-upload class="avatar-uploader" :http-request="uploadFile" accept=".jpg, .png" action=""
            :show-file-list="false" :before-upload="beforeAvatarUpload">
            <img v-if="boardForm.companyLogo" :src="boardForm.companyLogo" class="avatar"/>
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>

        <el-form-item label="企业Id" label-width="140px" v-show="false">
          <el-input class="form-item" v-model="boardForm.companyId" disabled="true"  clearable></el-input>
        </el-form-item>

        <el-form-item label="用戶Id" label-width="140px" v-show="false">
          <el-input class="form-item" v-model="boardForm.userId" disabled="true" clearable></el-input>
        </el-form-item>

        <el-form-item label="企业名称" label-width="140px">
          <el-input class="form-item" v-model="boardForm.companyName" placeholder="请输入企业名称..." clearable></el-input>
        </el-form-item>

        <el-form-item label="统一社会信用代码" label-width="140px">
          <el-input class="form-item" v-model="boardForm.socialCreditCode" placeholder="统一社会信用代码" :disabled="true"
            clearable></el-input>
        </el-form-item>

        <el-form-item label="公司类型" label-width="140px">
          <el-select class="form-item" v-model.number="boardForm.companyType" clearable placeholder="请选择">
            <el-option v-for="item in allCompanyType" :key="item.value" :label="item.name" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="注册资金" label-width="140px">
          <el-input class="form-item" v-model="boardForm.registeredCapital" placeholder="请输入注册资金..."
            clearable></el-input>
        </el-form-item>

        <el-form-item label="注册地址" label-width="140px">
          <el-input class="form-item" v-model="boardForm.registeredAddress" placeholder="请输入注册地址..."
            clearable></el-input>
        </el-form-item>

        <el-form-item label="法人代表" label-width="140px">
          <el-input class="form-item" v-model="boardForm.legalPerson" placeholder="请输入法人代表..." clearable></el-input>
        </el-form-item>

        <el-form-item label="成立日期" label-width="140px">
          <el-date-picker class="form-item" type="date" placeholder="选择日期" v-model="boardForm.setUpTime"
            clearable></el-date-picker>
        </el-form-item>

        <el-form-item label="经营期限" label-width="140px">
          <el-input class="form-item" v-model="boardForm.operatingPeriod" placeholder="例: xxxx年xx月xx日 至 xxxx年xx月xx日"
            clearable></el-input>
        </el-form-item>

        <el-form-item label="经营范围" prop="operatingPeriod" label-width="140px">
          <el-input class="form-item" type="textarea" rows="3" v-model="boardForm.businessNature"
            placeholder="请输入经营范围..." clearable></el-input>
        </el-form-item>

        <el-form-item label="开户行" label-width="140px">
          <el-input class="form-item" v-model="boardForm.accountBankName" placeholder="请输入开户行..." clearable></el-input>
        </el-form-item>

        <el-form-item label="对公账户名称" label-width="140px">
          <el-input class="form-item" v-model="boardForm.accountName" placeholder="请输入对公账户名称..." clearable></el-input>
        </el-form-item>

        <el-form-item label="对公账户" label-width="140px">
          <el-input class="form-item" v-model="boardForm.accountCode" placeholder="请输入对公账户..." clearable></el-input>
        </el-form-item>

        <el-form-item label="联系人姓名" label-width="140px">
          <el-input class="form-item" v-model="boardForm.contactsName" placeholder="请输入联系人姓名..." clearable></el-input>
        </el-form-item>

        <el-form-item label="联系人电话" label-width="140px">
          <el-input class="form-item" v-model="boardForm.contactsPhone" placeholder="请输入联系人电话..." clearable></el-input>
        </el-form-item>

        <el-form-item label="联系人邮箱" label-width="140px">
          <el-input class="form-item" v-model="boardForm.contactsEmail" placeholder="请输入联系人邮箱..." clearable></el-input>
        </el-form-item>

        <el-form-item label="经办人是否为法人" label-width="140px">
          <el-radio-group v-model="boardForm.isLegalPerson">
            <el-radio label="是" value="是"></el-radio>
            <el-radio label="否" value="否"></el-radio>
          </el-radio-group>
        </el-form-item>

        <div class="container" label-width="140px">
          <div class="item">&nbsp; &nbsp; 法人身份证照片</div>
          <div class="item"></div>
        </div>

        <div class="container">
          <div class="item">
            <el-form-item label="正面" prop="legalPersonIdCardFront" label-width="140px">
              <el-upload class="avatar-uploader" :http-request="uploadFile1" accept=".jpg, .png" action=""
                :show-file-list="false" :before-upload="beforeAvatarUpload">
                <img v-if="boardForm.legalPersonIdCardFront" :src="boardForm.legalPersonIdCardFront" class="avatar" />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
          </div>
          <div class="item">
            <el-form-item label="背面" prop="legalPersonIdCardBack" label-width="140px">
              <el-upload class="avatar-uploader" :http-request="uploadFile2" accept=".jpg, .png" action=""
                :show-file-list="false" :before-upload="beforeAvatarUpload">
                <img v-if="boardForm.legalPersonIdCardBack" :src="boardForm.legalPersonIdCardBack" class="avatar"/>
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
          </div>
        </div>
      </el-card>
    </el-form>
    <div style="text-align: center; margin-top: 20px">
      <el-button type="primary" @click="submitBoard">提交</el-button>
      <el-button @click="resetForm">重置</el-button>
    </div>
  </div>
</template>

<script>
import E from "wangeditor";
export default {
  name: "DetailModify",
  props: {
    socialCreditCode: {
      type: String,
      default: ''
    }
  },
  mounted() {
    //console.log('Received socialCreditCode:', this.socialCreditCode);
  },
  created() {
    //console.log('Initializing with socialCreditCode:', this.socialCreditCode);
    this.boardForm.socialCreditCode = this.socialCreditCode;
  },
  data() {
    return {
      boardForm: {
        id: "",
        typeName: "",
        title: "",
        published: true,
        content: "",
        companyId: "",
        userId: "",
        companyName: "",
        companyLogo: "",
        socialCreditCode: this.socialCreditCode || "",
        companyType: "",
        registeredCapital: "",

        legalPerson: "",
        setUpTime: "",
        //operatingPeriod: "2008-01-01 至 2028-01-01",

        accountBankName: "",
        accountName: "",
        accountCode: "",

        contactsName: "",
        contactsPhone: "",
        contactsEmail: "",

        registeredAddress: "",
        businessNature: "",
        isLegalPerson: "",

        picture: "",
        avatar: "",

        legalPersonIdCardFront: "",
        legalPersonIdCardBack: "",

        color: "#00bcd4",
      },
      editor: null,
      htmlCode: "",
      allTypes: [
        {
          value: "全民所有制企业",
          name: "全民所有制企业",
        },
        {
          value: "有限责任公司",
          name: "有限责任公司",
        },
      ],

      allCompanyType: [
        {
          value: "全民所有制企业",
          name: "全民所有制企业",
        },
        {
          value: "有限责任公司",
          name: "有限责任公司",
        },
        {
          value: "股份有限公司",
          name: "股份有限公司",
        },
        {
          value: "集体所有制",
          name: "集体所有制",
        },
        {
          value: "合伙企业",
          name: "合伙企业",
        },
        {
          value: "其他有限责任公司分公司",
          name: "其他有限责任公司分公司",
        },
        {
          value: "其他",
          name: "其他",
        },
      ],

      updateInfo: false,
      buttonName: "",
    };
  },
  watch: {},
  mounted() {

    //console.log("socialCreditCode：   " + this.socialCreditCode)

    this.initDetailInfo(this.socialCreditCode);


    let boardId = this.$store.state.currentBoardId;
    if (boardId !== -1) {
      this.updateInfo = true;
      this.buttonName = "更新";
      this.getRequest("/web/getBoard?id=" + boardId).then((resp) => {
        this.boardForm.typeName = resp.data.typeName;
        this.boardForm.id = resp.data.id;
        this.boardForm.title = resp.data.title;
        this.boardForm.content = resp.data.content;
        this.boardForm.published = resp.data.published;
        this.initEditor(this.boardForm.content);




      });
    } else {
      this.initEditor("");
      this.buttonName = "创建";
    }
  },
  methods: {
    navigateToDetailInfo() {
      this.$router.push({ name: 'DetailInfo' });
    },
    resetForm() {
      this.boardForm = {};
      this.editor.txt.clear();
    },
    initEditor(content) {
      this.editor = new E(this.$refs.editorElem);
      this.editor.customConfig.zIndex = 100;
      this.editor.customConfig.onchange = (html) => {
        this.boardForm.content = html;
      };
      this.editor.customConfig.menus = [
        // 菜单配置
        "head", // 标题
        "bold", // 粗体
        "fontSize", // 字号
        "fontName", // 字体
        "italic", // 斜体
        "underline", // 下划线
        "strikeThrough", // 删除线
        "foreColor", // 文字颜色
        "backColor", // 背景颜色
        "link", // 插入链接
        "list", // 列表
        "justify", // 对齐方式
        "quote", // 引用
        "emoticon", // 表情
        "table", // 表格
        "code", // 插入代码
        "undo", // 撤销
        "redo", // 重复
      ];
      this.editor.create(); // 创建富文本实例
      if (this.boardForm.content) {
        this.editor.txt.html(content);
      }
    },

    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 1;

      if (!isJPG && !isPNG) {
        this.$message.error("上传Logo图片只能是 jpg/png 的格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传Logo图片大小不能超过 1MB!");
      }
      return (isJPG || isPNG) && isLt2M;
    },
    uploadFile(file) {
      let formData = new FormData();
      formData.append("avatar", file.file);
      //传入其他的参数
      this.postFileRequest("/web/file/uploadAvatar", formData)
        .then((response) => {
          this.boardForm.companyLogo = response.data.object.imageUrl;
        })
        .catch((error) => {
          this.$message.error("上传失败，请稍后重试...");
        });
    },

    uploadFile1(file) {
      let formData = new FormData();
      formData.append("avatar", file.file);
      //传入其他的参数
      this.postFileRequest("/web/file/uploadAvatar", formData)
        .then((response) => {
          this.boardForm.legalPersonIdCardFront = response.data.object.imageUrl;
        })
        .catch((error) => {
          this.$message.error("上传失败，请稍后重试....");
        });
    },

    uploadFile2(file) {
      let formData = new FormData();
      formData.append("avatar", file.file);
      //传入其他的参数
      this.postFileRequest("/web/file/uploadAvatar", formData)
        .then((response) => {
          this.boardForm.legalPersonIdCardBack = response.data.object.imageUrl;
        })
        .catch((error) => {
          this.$message.error("上传失败，请稍后重试...");
        });
    },


    initDetailInfo(keyword) {

      //console.log("keyword：   " + keyword)

      let user = JSON.parse(window.localStorage.getItem('user'));
      //console.log("useid:  " + user.id)


      this.getRequest(
        "/web/company/query/queryInfo?userId=" + user.id
      ).then((resp) => {
        //console.log(resp.data.socialcreditcode);
        if (resp) {
          this.boardForm = resp.data;

        }

      });
    },

    submitBoard() {
      //console.log("Submitting company details...");
      this.postJsonRequest("/web/company/update/detail", this.boardForm).then((resp) => {
        if (resp.data.status === 406) {
          this.showErrorMessage(resp.data.object);
        } else {
          this.$message.success('修改成功');
          location.reload();
        }
      });
    },
    showErrorMessage(message) {
      this.$message.error(message);
    },
  },
};
</script>

<style>
.item {
  float: left;
  /* 或者 right，取决于你想要哪个元素在左边或右边 */
  width: 50%;
  /* 或者具体的像素值，确保两个div加起来等于父容器的宽度 */
}

.container::after {
  content: "";
  clear: both;
  /* 清除浮动 */
  display: table;
  /* 为了确保清除有效 */
}

.w-e-text-container {
  background-color: white;
  height: 450px !important;
}

.editor {
  margin-top: 40px;
  /*position: relative;
        margin-top: 200px;*/
}

.form-item {
  width: 400px;
  clear: both;
  /* 清除浮动 */
}

.board-form {
  margin-top: 20px;
}

.card-body {
  display: flex;
  align-items: center;
  height: 100px;
  padding: 0;
}
</style>
<style scoped>
.card-content {
  flex: 1;
  text-align: center;
  font-size: 14px;
  color: #999;
  padding: 0 20px;
}

.card-num {
  font-size: 30px;
}

.card-icon {
  font-size: 50px;
  width: 100px;
  height: 100px;
  text-align: center;
  line-height: 100px;
  color: #fff;
}

.bg1 {
  background: #2d8cf0;
}

.bg2 {
  background: #64d572;
}

.bg3 {
  background: #f25e43;
}

.bg4 {
  background: #e9a745;
}

.color1 {
  color: #2d8cf0;
}

.color2 {
  color: #64d572;
}

.color3 {
  color: #f25e43;
}

.color4 {
  color: #e9a745;
}

.chart {
  width: 100%;
  height: 400px;
}

.card-header {
  padding-left: 10px;
  margin-bottom: 20px;
}

.card-header-title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 5px;
}

.card-header-desc {
  font-size: 14px;
  color: #999;
}

.timeline-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 16px;
  color: #000;
}

.timeline-time,
.timeline-desc {
  font-size: 12px;
  color: #787878;
}

.rank-item {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.rank-item-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #f2f2f2;
  text-align: center;
  line-height: 40px;
  margin-right: 10px;
}

.rank-item-content {
  flex: 1;
}

.rank-item-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #343434;
  margin-bottom: 10px;
}

.rank-item-desc {
  font-size: 14px;
  color: #999;
}

.map-chart {
  width: 100%;
}

.paragraph-style {
  margin-bottom: 6px;
}

.div-style {
  margin-top: 20px;
}

.left-aligned-black-text {
  color: black;
  text-align: left;
  /* 通常text-align默认为left，但明确指定也无妨 */
}

.paragraph-style {
  margin-bottom: 6px;
}

.label-left {
  text-align: left !important;
  /* 使用!important确保覆盖默认样式 */
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
</style>